<template>
  <section
    class="user-dashboard"
    :style="`background-image: url(${background})`"
  >
    <div class="user-dashboard__overlay"></div>
    <div class="user-dashboard__components">
      <UserDetailsCard
        :userName="userName"
        :userEmail="userEmail"
        :membersUrl="membersUrl"
        :avatar="currentAvatar"
      ></UserDetailsCard>
      <UserDashboardMenu :routerOption="$route.params.mode"></UserDashboardMenu>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import UserDetailsCard from '@/components/user/user-dashboard/UserDetailsCard.vue'
import UserDashboardMenu from '@/components/user/user-dashboard/UserDashboardMenu.vue'

export default {
  name: 'UserDashboard',
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      userId: 'auth/userId',
      memberId: 'auth/memberId',
      profile: 'auth/userProfile',
      currentAvatar: 'user/currentAvatar',
    }),
    membersUrl() {
      return process.env.VUE_APP_MEMBERS_URL
    },
    userName() {
      return `${this.profile.first_name} ${this.profile.last_name}`
    },
    userEmail() {
      const { email } = this.profile
      return email
    },
    background() {
      return 'https://s3.amazonaws.com/my.ine.com/assets/dashboard/dashboard_header.png'
    },
  },
  components: {
    UserDetailsCard,
    UserDashboardMenu,
  },
  async created() {
    this.$store.dispatch('app/setIsPageLoading', false)
  },
}
</script>

<style lang="scss" scoped>
.user-dashboard {
  padding: 125px 32px;
  z-index: 1;
  position: relative;
  background-repeat: no-repeat;
  background-size: 100% auto;
  @include tablet {
    padding: 150px 64px;
  }
  @include desktop {
    padding: 200px 128px;
  }
  &__overlay {
    position: absolute;
    min-height: 200vh;
    width: 100%;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.8),
      rgba(0, 0, 0, 0.8),
      rgba(0, 0, 0, 0.8),
      var(--dark-gray)
    );
    right: 0;
    top: 0;
    z-index: -1;
  }
  &__components {
    padding: 0;
    margin: 0 auto;
    @include desktop {
      display: flex;
      align-items: flex-start;
      flex-wrap: nowrap;
    }
  }
}
</style>
